import React from 'react';
import { Callout } from '../deck/Callout';
import { StepList } from '../deck/StepList';
import { StepSlide } from '../deck/StepSlide';
import { ReviewMockup } from '../mockups/ReviewMockup';
export function ReviewSubmitSlide() {
  return <StepSlide step={7} title="Review and submit" visual={<ReviewMockup data-id="element-233" data-mp="3egz28cw7ecs8" />} visualLabel="Review and submit page with Edit buttons and the Agree and submit button marked" data-id="element-232" data-mp="3jfimm8v5fgih">
      <StepList items={[<>Read through the information (name, address, website). Scroll down to see it all.</>, <>
            If something looks wrong, click <strong data-id="element-235" data-mp="30j0on9ppikds">Edit</strong> next to it, or call Tim before
            submitting.
          </>, <>
            At the bottom of the page, click <strong data-id="element-236" data-mp="yqw10af8q98v">"Agree and submit"</strong>.
          </>]} data-id="element-234" data-mp="3ahq99a8zmixq" />
      <Callout data-id="element-237" data-mp="yos081cn1qct">
        See "You won't be able to submit until you complete all sections"? Check the left-side
        checklist and finish any step that isn't done.
      </Callout>
    </StepSlide>;
}